import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {API_URL} from "../../../utils/Common";

const PorcentajeColor = (props) => {
    const {cantidad, idreg} = props;

    const [valor, setValor] = useState(0);

    useEffect(() => setValor(cantidad), [cantidad])

    const onChange = (e) => {
        setValor(e.target.value === ''?0:e.target.value);
        setPor(e.target.value === ''?0:e.target.value);
    }

    const setPor = (valor) => {
        axios.post(API_URL + '/setPorColor', {valor, idreg})
            .then(r => console.log(r.data))
            .catch(e => console.log(e));
    }

    return (
        <input className={valor > 0?"mt-1 text-xs text-right appearance-none block w-20 bg-indigo-200 text-gray-700 border border-indigo-200 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500":
            "text-xs text-right appearance-none block w-20 bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"}
               type="text"
               name="cantidad"
               value={valor}
               onChange={onChange}
               onFocus={($event) => $event.target.select()}/>
    )
}

export default PorcentajeColor;
